<template>
  <div class="FAQtable">
    <accordion>
      <accordion-item>
        <template slot="accordion-trigger">
          <h5>
            There is no product next to the QR code but e-store shows there is
            product available?
          </h5>
        </template>
        <template slot="accordion-content">
          <span class="accordion-content"
            >You can complete the purchase and then call or send email with
            delivery address and product will be shipped to your address.</span
          >
        </template>
      </accordion-item>

      <!-- <accordion-item>
          <template slot="accordion-trigger">
            <h5>Can I send the product to my address?</h5>
          </template>
          <template slot="accordion-content">
            <br/>
            <span>This service is still under development and will be available soon.</span>
            <br/>
          </template>
        </accordion-item> -->
      <!-- 
        <accordion-item>
          <template slot="accordion-trigger">
            <h5>{{ $t('faq3q') }}</h5>
          </template>
          <template slot="accordion-content">
            <br/>
            <span>Not a problem. Tutorial below will show you where the Stripe test and live API can be found.</span>
            <br/>
          </template>
        </accordion-item> -->
    </accordion>
  </div>
</template>

<script>
import Accordion from '@/components/common/accordion'
import AccordionItem from '@/components/common/accordion-item'

export default {
  components: {
    Accordion,
    AccordionItem
  }
}
</script>

<style lang="scss" scoped>
.FAQtable h5 {
  font-size: 1.8em;
  font-weight: 600;
  text-align: left;
}
.FAQtable ul {
  text-align: left;
}
.FAQtable {
  margin: 0% 20% 5% 6%;
}
.resp-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  // max-width: 400px;
  // max-height: 100px;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.accordion-content {
  color: var(--grey);
}

/* Then style the iframe to fit in the container div with full height and width */
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.responsive {
  width: 100%;
  height: auto;
}
.stripeLogo {
  max-width: 250px;
}
@media screen and (max-width: 700px) {
  .FAQtable {
    margin: 3% 3% 10% 3%;
    text-align: left;
  }
  .FAQtable h5 {
    font-size: 1.3em;
    font-weight: 400;
  }
}
</style>
